import { render, staticRenderFns } from "./LandCard.vue?vue&type=template&id=7f9fe2e3&scoped=true"
import script from "./LandCard.vue?vue&type=script&lang=js"
export * from "./LandCard.vue?vue&type=script&lang=js"
import style0 from "./LandCard.vue?vue&type=style&index=0&id=7f9fe2e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9fe2e3",
  null
  
)

export default component.exports